import React, {useMemo, useContext} from "react";
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TrainerLayout from "./TrainerLayout";
import TrainerAccountDetails from "./TrainerAccountDetails";
import TrainerWorkingHoursContent from "./TrainerWorkingHoursContent";
import Tabs from "../commons/Tabs";
import { isOwner } from "../../utils/trainerRoleUtils";
import "../../styles/Tabs.css";
import "../../styles/AccountDetails.css";
import "../../styles/TrainerWorkingHours.css";
import SubscriptionTab from "../subscription/SubscriptionTab";
import {TrainerContext} from "../../context/TrainerContext";

const TrainerAccount = () => {
    const { t } = useTranslation(['account']);
    const { trainer } = useContext(TrainerContext);
    const [searchParams] = useSearchParams();
    const initialTab = searchParams.get('tab');

    // Get current user's role in their school
    const currentUserRole = trainer?.trainerSchoolRole;

    // Build tabs based on user role
    const tabs = useMemo(() => {
        const baseTabs = [
            { key: "account", label: t('account:tabs.accountData'), component: <TrainerAccountDetails /> },
            { key: "workingHours", label: t('account:tabs.hours'), component: <TrainerWorkingHoursContent /> }
        ];

        // Only show subscription tab for School Owners
        if (isOwner(currentUserRole)) {
            baseTabs.push({ key: "subscription", label: t('account:tabs.subscription'), component: <SubscriptionTab /> });
        }

        return baseTabs;
    }, [currentUserRole, t]);

    return (
        <TrainerLayout>
            <div className="trainer-account-container">
                <Tabs tabs={tabs} initialTab={initialTab} />
            </div>
        </TrainerLayout>
    );
};

export default TrainerAccount;
